export const formatearNum = (numero: any) => {
  if (!numero) return null;
  return numero.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}) ?? '--'
}

// Descuento global del documento (resumen.descuNoSuj + descuExenta + descuGravada); 0 en documentos sin descuento global
export const descuentoGlobalDe = (resumen: any): number =>
  Math.round(((parseFloat(resumen?.descuNoSuj) || 0) + (parseFloat(resumen?.descuExenta) || 0) + (parseFloat(resumen?.descuGravada) || 0)) * 100) / 100

// Credito fiscal, nota credito y debito
export const TotalesCFF = ({resumen}: {resumen: any}) => {
  return (
    <>
      {(resumen) &&
      (
      <tbody>
        <tr className="cf-subtotal">
            <td>Suma de operaciones</td>
            <td>{formatearNum(resumen?.subTotalVentas) ?? '--'}</td>
        </tr>
        {descuentoGlobalDe(resumen) > 0 && (
        <tr className="cf-descuento">
            <td>Descuento global</td>
            <td>-{formatearNum(descuentoGlobalDe(resumen))}</td>
        </tr>
        )}
        <tr className="cf-subtotal">
            <td>Impuesto al Valor Agregado 13%</td>
            <td>{formatearNum(resumen?.tributos[0]?.valor)}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Otros impuestos</td>
            <td>{formatearNum(resumen?.totalTributosSinIva) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Subtotal</td>
            <td>{formatearNum(resumen?.montoTotalOperacion) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA percibido 1%</td>
            <td>{formatearNum(resumen?.ivaPerci1) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA retenido 1%</td>
            <td>{formatearNum(resumen?.ivaRete1) ?? '--'}</td>
        </tr>
        <tr className="cf-descuento">
            <td>Retencion renta 10%</td>
            <td>{formatearNum(resumen?.reteRenta) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Total Otros Montos No Afectados</td>
            <td>{formatearNum(resumen?.totalNoGravado ?? 0)}</td>
        </tr>
        <tr className="cf-total">
            <td>Total</td>
            <td>{formatearNum(resumen?.totalPagar) ?? formatearNum(resumen?.montoTotalOperacion) ?? '--'}</td>
        </tr>
      </tbody>
      )}
    </>
  )
}

export const TotalesCF = ({resumen}: {resumen: any}) => {
  return (
    <>
      {(resumen) &&
      (
      <tbody>
        <tr className="cf-subtotal">
            <td>Suma de operaciones</td>
            <td>{formatearNum(resumen?.subTotalVentas) ?? '--'}</td>
        </tr>
        {descuentoGlobalDe(resumen) > 0 && (
        <tr className="cf-descuento">
            <td>Descuento global</td>
            <td>-{formatearNum(descuentoGlobalDe(resumen))}</td>
        </tr>
        )}
        <tr className="cf-subtotal">
            <td>Impuesto al Valor Agregado 13%</td>
            <td>{formatearNum(resumen?.totalIva) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Subtotal</td>
            <td>{formatearNum(Math.round(((parseFloat(resumen?.subTotalVentas) || 0) - descuentoGlobalDe(resumen)) * 100) / 100) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Otros impuestos</td>
            <td>{formatearNum(resumen?.totalTributosSinIva) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA percibido 1%</td>
            <td>{formatearNum(resumen?.ivaPerci1) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA retenido 1%</td>
            <td>{formatearNum(resumen?.ivaRete1) ?? '--'}</td>
        </tr>
        <tr className="cf-descuento">
            <td>Retencion renta 10%</td>
            <td>{formatearNum(resumen?.reteRenta) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Total Otros Montos No Afectados</td>
            <td>{formatearNum(resumen?.totalNoGravado ?? 0)}</td>
        </tr>
        <tr className="cf-total">
            <td>Total</td>
            <td>{formatearNum(resumen?.totalPagar) ?? formatearNum(resumen?.montoTotalOperacion) ?? '--'}</td>
        </tr>
      </tbody>
      )}
    </>
  )
}

export const TotalesSujeto = ({resumen}: {resumen: any}) => {
  return (
    <>
      {(resumen) && 
      (
      <tbody>
        <tr className="cf-subtotal">
            <td>Suma de operaciones</td>
            <td>{formatearNum(resumen?.totalCompra) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Impuesto al Valor Agregado 13%</td>
            <td>{'--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Subtotal</td>
            <td>{formatearNum(resumen?.subTotal) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA percibido 1%</td>
            <td>{formatearNum(resumen?.ivaPerci1) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA retenido 1%</td>
            <td>{formatearNum(resumen?.ivaRete1) ?? '--'}</td>
        </tr>
        <tr className="cf-descuento">
            <td>Retencion renta 10%</td>
            <td>{formatearNum(resumen?.reteRenta) ?? '--'}</td>
        </tr>
        <tr className="cf-total">
            <td>Total</td>
            <td>{formatearNum(resumen?.totalPagar) ?? formatearNum(resumen?.montoTotalOperacion) ?? '--'}</td>
        </tr>
      </tbody>
      )}
    </> 
  )
}

export const TotalesCL = ({resumen}: {resumen: any}) => {
  return (
    <>
      {(resumen) && 
      (
      <tbody>
        <tr className="cf-subtotal">
            <td>Total de operaciones no sujetas</td>
            <td>{formatearNum(resumen?.totalNoSuj) ?? '$0.00'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Total de operaciones exentas</td>
            <td>{formatearNum(resumen?.totalExenta) ?? '$0.00'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Total de operaciones gravadas</td>
            <td>{formatearNum(resumen?.totalGravada) ?? '$0.00'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Total de operaciones de exportación</td>
            <td>{formatearNum(resumen?.totalExportacion) ?? '$0.00'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Monto total de la operación</td>
            <td>{formatearNum(resumen?.montoTotalOperacion) ?? '$0.00'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Impuesto al Valor Agregado 13%</td>
            <td>{formatearNum(resumen?.tributos?.find((imp: any) => imp.codigo === '20')?.valor) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA percibido 1%</td>
            <td>{formatearNum(resumen?.ivaPerci) ?? '--'}</td>
        </tr>
        <tr className="cf-total">
            <td>Total</td>
            <td>{formatearNum(resumen?.totalPagar) ?? formatearNum(resumen?.montoTotalOperacion) ?? '--'}</td>
        </tr>
      </tbody>
      )}
    </> 
  )
}

export const TotalesExportacion = ({resumen}: {resumen: any}) => {
  return (
    <>
      {(resumen) && 
      (
      <tbody>
        <tr className="cf-subtotal">
            <td>Suma de operaciones</td>
            <td>{formatearNum(resumen?.totalPagar) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Seguro</td>
            <td>{formatearNum(parseInt(resumen?.seguro)) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Flete</td>
            <td>{formatearNum(parseInt(resumen?.flete)) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Subtotal</td>
            <td>{formatearNum(parseInt(resumen?.expSubtotal)) ?? '--'}</td>
        </tr>
        <tr className="cf-descuento">
            <td>Descuento</td>
            <td>{formatearNum(parseInt(resumen?.descuentoGlobal)) ?? '--'}</td>
        </tr>
        <tr className="cf-total">
            <td>Total</td>
            <td>{formatearNum(parseInt(resumen?.extTotal)) ?? '--'}</td>
        </tr>
      </tbody>
      )}
    </> 
  )
}

export const TotalesNotaRemision = ({resumen}: {resumen: any}) => {
  return (
    <>
      {(resumen) && 
      (
      <tbody>
        <tr className="cf-subtotal">
            <td>Suma de operaciones</td>
            <td>{formatearNum(resumen?.totalGravada) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Impuesto al Valor Agregado 13%</td>
            <td>{formatearNum(resumen?.tributos[0]?.valor)}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Otros impuestos</td>
            <td>{formatearNum(resumen?.totalTributosSinIva) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Subtotal</td>
            <td>{formatearNum(resumen?.subTotalVentas) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA percibido 1%</td>
            <td>{formatearNum(resumen?.ivaPerci1) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA retenido 1%</td>
            <td>{formatearNum(resumen?.ivaRete1) ?? '--'}</td>
        </tr>
        <tr className="cf-descuento">
            <td>Retencion renta 10%</td>
            <td>{formatearNum(resumen?.reteRenta) ?? '--'}</td>
        </tr>
        <tr className="cf-total">
            <td>Total</td>
            <td>{formatearNum(resumen?.totalPagar) ?? formatearNum(resumen?.montoTotalOperacion) ?? '--'}</td>
        </tr>
      </tbody>
      )}
    </> 
  )
}


export const TotalesComprobanteRetencion = ({resumen}: {resumen: any}) => {
  return (
    <>
      {(resumen) && 
      (
      <tbody>
        <tr className="cf-total">
            <td>Total monto sujeto a retención</td>
            <td>{formatearNum(resumen?.totalSujetoRetencion) ?? '--'}</td>
        </tr>
        <tr className="cf-descuento">
            <td>Total IVA retenido:</td>
            <td>{formatearNum(resumen?.totalIVAretenido) ?? '--'}</td>
        </tr>
      </tbody>
      )}
    </> 
  )
}
